<div class="" style="padding-right: 5px;padding-top: 1px;width: 132px;height:35px;">
    <div class="input-group" dropdown #dropdown="bs-dropdown">
        <div class="input-group-prepend" id="addressbookicon">
            <span (click)="newAddressBook();" matTooltip="Nouvelle address" matTooltipPosition="above" class="input-group-text addressicon fakelink">
                <fa-icon [icon]="['fas','address-book']"></fa-icon>
            </span>
        </div>        
        <input [(ngModel)]="addressbooksearchvalue" [disabled]="addressbook.searchingaddress" (keydown.enter)="searchAddressBook($event);" type="text" class="form-control" style="width: 87px;height: 27px;font-size: 10px;" placeholder="Carnet d'adresse">
        <button type="button" dropdownToggle id="searchaddressbookdropdown" data-toggle="dropdown" style="display:none;"></button>
        <ul class="dropdown-menu searchaddressbookdropdown" *dropdownMenu>
            <li *ngFor="let address of addressbookresults" class="addressresult">
                <div class="row">
                        <div class="col-md-4">{{address.firstname}}</div><div class="col-md-5">{{address.lastname}}</div>
                        <div *ngIf="address.company.length != 0" class="col-md-9">{{address.company}}</div>
                        <div class="col-md-9">{{address.street}}</div>
                        <div class="col-md-4">{{address.zipcode}}</div><div class="col-md-5">{{address.city}}</div>
                        <div class="col-md-4">{{address.phone}}</div><div class="col-md-5">{{address.mobile}}</div>
                        <div class="col-md-4">{{address.fax}}</div><div class="col-md-5">{{address.email}}</div>
                        <div class="col-md-9">{{address.comment}}</div>
                </div>
            </li>
        </ul>
    </div>	
</div>
